import {
	Component,
	EventEmitter,
	Output,
	ViewChild,
	ChangeDetectionStrategy,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import {
	MatTableDataSource,
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-ca-pending-voe',
	templateUrl: './ca-pending-voe.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		'table {display:block; margin-bottom:1em}',
		'.mat-mdc-table {width: 100%;max-height: 500px;overflow: auto;}',
		'tr.element-row:hover{background: whitesmoke}',
		'a {text-decoration: none;}',
		'.loading-shade {position: absolute;top: 0;left: 0;bottom: 56px;right: 0;background: rgba(136, 134, 134, 0.15);z-index: 1;display: flex;align-items: center;justify-content: center;}',
	],
	imports: [
		NgIf,
		MatProgressSpinner,
		MatTable,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		RouterLink,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		MatPaginator,
	],
})
export class CaPendingVoeComponent {
	@ViewChild('paginator') paginator: MatPaginator;
	@Output() sendCAPendingVOE = new EventEmitter<any>();
	constructor(private apiService: LegacyApiService) {}
	caPendingVOEColumns: string[] = ['name', 'province', 'agencyName', 'note'];
	dataSourceCAPendingVOE: MatTableDataSource<string[]>;
	isLoading = true;
	totalCAPendingVOE: number;
	serviceSubscription: Subscription;
	async ngAfterViewInit(): Promise<void> {
		this.dataSourceCAPendingVOE = new MatTableDataSource(
			await this.needsCAPendingVOE(['Conditionally Approved Pending VOE'])
		);
		this.dataSourceCAPendingVOE.paginator = this.paginator;
		this.totalCAPendingVOE = this.dataSourceCAPendingVOE.filteredData
			?.map((item: any) => item.Amount)
			.reduce((prev, next) => prev + next, 0);
		this.sendTotalCountandAmount(
			this.dataSourceCAPendingVOE?.filteredData.length,
			this.totalCAPendingVOE
		);
	}

	needsCAPendingVOE(stageName): Promise<any> {
		return new Promise((resolve, reject) => {
			this.isLoading = true;
			this.serviceSubscription = this.apiService
				.underwritingDashboardQueues(stageName)
				.subscribe((res: any) => {
					if (res.message.statusCode === 200) {
						const arr = JSON.parse(res.message.body);
						this.isLoading = false;
						resolve(arr.data);
					} else {
						this.isLoading = false;
						resolve([]);
					}
				});
		});
	}

	sendTotalCountandAmount(count: number, amount: number) {
		const result = { count: count, amount: amount };
		this.sendCAPendingVOE.emit(result);
	}

	ngOnDestroy() {
		this.serviceSubscription.unsubscribe();
	}
}
